import React from 'react';
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleWhiteIcon from '../../../icons/check-circle-white.svg'
import SvgIcon from '@material-ui/core/SvgIcon';

function FancyButton(props) {

    const useStyles = makeStyles(() => ({
        styledButton: {
            height: '4rem',
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
            textTransform: 'none',
            backgroundColor:'rgba(255,255,255,1)',
        },
        styledButtonError: {
            border: '1px solid red !important',
        },
        styledButtonInactive: {
            border: 'none',
        },
        styledIcon: {
            marginLeft: 'auto',
        },
        styledLabel: {
            marginRight: 'auto',
        },
        styledCheck: {
            marginLeft: 'auto',
        },

    }));

    const classes = useStyles();

    const buttonClasses = `${classes.styledButton} ${(props.active ? classes.styledButtonActive : classes.styledButtonInactive)} ${(props.error ? classes.styledButtonError : '')}`;

    return (
        <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true" disabled={props.disabled}>
            {props.icon && <div className={`${classes.styledIcon} mr-2`}>{props.icon}</div>}
            <div className={classes.styledLabel}>{props.label}</div>
            <div className={classes.styledCheck}>
                {props.active ? <CheckCircleIcon className="ml-3" htmlColor={props.active ? '' : '#bbb'} /> : <SvgIcon color="primary" component={CheckCircleWhiteIcon} />}
            </div>
        </Button>
    )
}

export default function StyledRadioInput(props) {

    const useStyles = makeStyles(() => ({
        label: {
            color: 'rgba(0, 0, 0, 0.54)',
            padding: '0',
            fontSize: '1rem',
            fontFamily: '"museo-sans", "Helvetica", "Arial", sans-serif',
            fontWeight: '400',
            lineHeight: '1',
        },
        labelCenter: {
            color: '#000000DE',
            padding: '0',
            fontSize: '1rem',
            fontFamily: '"museo-sans", "Helvetica", "Arial", sans-serif',
            fontWeight: '400',
            lineHeight: '1',
            textAlign: 'center',
            marginBottom: '12px'
        },
        radioBtnLeft:{
            paddingRight:'5px',
        },
        radioBtnRight:{
            paddingLeft:'5px',
        }
    }));

    const classes = useStyles();

    return (
        <div>
            {props.label && <legend className={`text-left ${props.labelCenter ? classes.labelCenter : classes.label}`}>{props.label}</legend>}
            <Row className='radio-input'>
            {props.isTermHelpOptions === true ?
              props.options.map((x, i) => (
                <Col xs={props.colWidth || 6} className={!props.isTermQuoterPage ? classes.radioBtnLeft : ''}>
                    <Form.Group>
                       <FancyButton
                            active={props.value === props.options[i].value}
                            icon={props.options[i].icon}
                            label={props.options[i].label}
                            onClick={() => props.onChange(props.options[i].value)}
                            error={!!props.errors}
                            disabled={props.disabled}
                        />
                    </Form.Group>
                </Col>
                ))
                :
                <React.Fragment>
                    <Col xs={props.isTermQuoterPage ? 12 : 6} className={!props.isTermQuoterPage ? classes.radioBtnLeft : ''}>
                        <Form.Group>
                            <FancyButton
                                active={props.value === props.options[0].value}
                                icon={props.options[0].icon}
                                label={props.options[0].label}
                                onClick={() => props.onChange(props.options[0].value)}
                                error={!!props.errors}
                                disabled={props.disabled}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={props.isTermQuoterPage ? 12 : 6} className={!props.isTermQuoterPage ? classes.radioBtnRight : ''}>
                        <Form.Group>
                            <FancyButton
                                active={props.value === props.options[1].value}
                                icon={props.options[1].icon}
                                label={props.options[1].label}
                                onClick={() => props.onChange(props.options[1].value)}
                                error={!!props.errors}
                                disabled={props.disabled}
                            />
                        </Form.Group>
                    </Col>
                </React.Fragment>
            }
                {props.errors && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block">{props.errors.message}</span>}
            </Row>
        </div>
    )
}

StyledRadioInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
      ]).isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool
          ]).isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.object,
    })),
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/StyledRadioInput.js